export const DEVICE_SEVERITY_WARNING = 'WARNING';
export const DEVICE_SEVERITY_ERROR = 'ERROR';
export const DEVICE_TYPE = {
    AIR_COND: 'aircon',
    ALARM_SYSTEM: 'alarm',
    BLENDER: 'blender',
    COFFEE_MACHINE: 'coffee',
    COINS: 'COINS',
    COMPUTER: 'computer',
    COOKER: 'cooker',
    COOKER_PLATE: 'cookingPlate',
    CENTRAL_HEATING: 'heating',
    DEFAULT: 'unknown',
    DISHWASHER: 'dishwasher',
    DRYING_MACHINE: 'drying',
    ELECTRICAL_CAR: 'EV',
    EXCLAMATION: 'EXCLAMATION',
    ELECTRIC_HEATER: 'heater',
    FAN: 'fan',
    FAN_HEATER: 'fanHeater',
    FAX_MACHINE: 'fax',
    FREEZER: 'freezer',
    FRIDGE: 'fridge',
    IRON: 'iron',
    GRILL: 'grill',
    HEATING_THERMOSTAT: 'thermostat',
    HEATER: 'heater',
    HAIR_DRYER: 'dryer',
    JACUZZI: 'jacuzzi',
    KETTLE: 'kettle',
    KITCHEN_HOOD: 'hood',
    LAMP: 'lamp',
    LIGHT: 'light',
    LIGHTNING: '',
    MICROWAVE: 'microwave',
    MOBILE_CHARGER: 'charger',
    OVEN: 'oven',
    PLUGS: 'plugs',
    PUMP: 'pump',
    POWER_SOCKET: 'socket',
    PRINTER: 'printer',
    RADIO: 'radio',
    SOUND_SYSTEM: 'sound',
    SPA: 'spa',
    SOLAR_HEATING: 'solar',
    SERVER: 'server',
    SELF_STANDING_LAMP: 'standingLamp',
    STOVE: 'stove',
    TV: 'TV',
    TOASTER: 'toaster',
    VENTILATION_SYSTEM: 'ventilation',
    VACUUM_CLEANER: 'vacuumCleaner',
    WASH_MACHINE: 'washer',
    WATER_HEATER: 'waterHeater'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/house.constants.js